
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, List, ListItem, Typography } from "@mui/material"

import moment from "moment"

import { formatCurrency } from "../helpers/FormatCurrency"
import { InfoField } from "../components/InfoField"

import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle"

import { ExpedienteProps } from "../interfaces/recepcion/ExpedienteInterface"

interface Props {
    expediente?:        ExpedienteProps;
    openDialog:         boolean;
    handleCloseDialog:  () => void;
}

export const DialogExpediente = ({ expediente, openDialog, handleCloseDialog }: Props) => {

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>
                Información del expediente
            </DialogTitle>

            <DialogContent sx={{ ...DialogContentStyle, pt: 3 }}>

                <Grid container spacing={3}>

                    {
                        expediente?.numeroFolio
                        ?
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Número de expediente"
                                    value={
                                        <>
                                            { expediente?.numeroExpediente }
                                            { expediente?.numeroFolio && <small style={{ fontSize: 14 }}> (F. { expediente?.numeroFolio })</small> }
                                        </>
                                    }
                                    fontSize={ 16 }
                                />
                            </Grid>
                        :
                            expediente?.numeroExpediente
                            &&
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <InfoField
                                        label="Número de expediente"
                                        value={ expediente?.numeroExpediente }
                                        fontSize={ 16 }
                                    />
                                </Grid>
                    }

                    {
                        expediente?.fecha
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Fecha"
                                    value={ moment( new Date( expediente?.fecha ) ).format( 'DD-MM-YYYY' ) }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.tipoJuicio
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Tipo de juicio"
                                    value={ expediente?.tipoJuicio }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.cuantia
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Cuantía"
                                    value={ formatCurrency( expediente?.cuantia ) }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        ( expediente?.etapa && expediente?.subEtapa )
                        ?
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Etapa"
                                    value={ `${ expediente?.etapa } (${ expediente?.subEtapa })` }
                                    fontSize={ 16 }
                                />
                            </Grid>
                        :
                            expediente?.etapa
                            &&
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <InfoField
                                        label="Etapa"
                                        value={ expediente?.etapa }
                                        fontSize={ 16 }
                                    />
                                </Grid>
                    }

                    {
                        expediente?.juez
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Juez"
                                    value={ expediente?.juez }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.secretario
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Secretario(a) admisibilidad"
                                    value={ expediente?.secretario }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.secretarioTramite
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Secretario(a) trámite (Mayor cuantía)"
                                    value={ expediente?.secretarioTramite }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.secretarioTramiteMenor
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Secretario(a) trámite (Menor cuantía)"
                                    value={ expediente?.secretarioTramiteMenor }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.secretarioEjecucion
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Secretario(a) ejecución"
                                    value={ expediente?.secretarioEjecucion }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        expediente?.juzgadoOrigen
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Juzgado de origen"
                                    value={ expediente?.juzgadoOrigen }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        ( expediente?.actores && expediente.actores.length !== 0 )
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Actor(es):
                                </Typography>

                                <List disablePadding>
                                    {
                                        expediente.actores.map( (actor, index) => (
                                            <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight='bold' fontSize={ 16 }>{ actor }</Typography>
                                            </ListItem>
                                        ))
                                    }
                                </List>

                            </Grid>
                    }

                    {
                        ( expediente?.demandados && expediente.demandados.length !== 0 )
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Demandado(s):
                                </Typography>

                                <List disablePadding>
                                    {
                                        expediente.demandados.map( (demandado, index) => (
                                            <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight='bold' fontSize={ 16 }>{ demandado }</Typography>
                                            </ListItem>
                                        ))
                                    }
                                </List>

                            </Grid>
                    }

                    {
                        ( expediente?.prestaciones && expediente.prestaciones.length !== 0 )
                        &&
                            <Grid size={{ md: 12, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Prestación(es) o Pretención(es):
                                </Typography>

                                <List disablePadding>
                                    {
                                        expediente.prestaciones.map( (prestacion, index) => (
                                            <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight='bold' fontSize={ 16 }>{ prestacion }</Typography>
                                            </ListItem>
                                        ))
                                    }
                                </List>

                            </Grid>
                    }

                    {
                        expediente?.digitalizacion
                        &&
                            <Grid size={{ md: 12, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Digitalización:
                                </Typography>

                                <iframe
                                    title='iframe-documento'
                                    style={{ width: '100%', height: 500, borderRadius: 8 }}
                                    src={ expediente?.digitalizacion ?? '' }
                                />

                            </Grid>
                    }

                </Grid>

            </DialogContent>

            <DialogActions sx={{ ...DialogActionsStyle }}>
                <Button color="secondary" onClick={ handleCloseDialog }>Cerrar</Button>
            </DialogActions>

        </Dialog>
    )
}
